module.exports = __webpack_public_path__ + "static/packages-cover-9377671f1e1628dceb4aca944d4d6829.png";